import { Component } from '@angular/core';
import { EmployeeRegistrationService } from '../../Model/EmployeeRegistration/employee-registration.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { CommonService } from '../../Model/Common/common.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-register-init-form',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './register-init-form.component.html',
  styleUrl: './register-init-form.component.scss'
})
export class RegisterInitFormComponent {
  isDisabled: boolean = false;
  RegistrationTypes: any = [{ RegistrationTypeID: 1, RegistrationType: 'Manual Registration', Value: 'Manual', disabled: false },
  { RegistrationTypeID: 2, RegistrationType: 'Pre Onboarding', Value: 'PreOnboarding', disabled: false }]

  RegistrationTypesFilter = [] as any;
  EmployeeDetail = {
    SelectType: 'ei',
    FirstName: null,
    EmailId: null,
    MobileNo: null,
    EmpTempCode: "",
    RegistrationType: '',
    EmployeeCategory: '',
    IsDraft: true,
  }

  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    private router: Router,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) {
    if (this.common.ToLowerCase(this.router.url.split('/')[3]) == 'menualinit') {
      this.EmployeeDetail.RegistrationType = 'Manual';
      this.RegistrationTypesFilter = this.RegistrationTypes.filter((e: any) => e.RegistrationTypeID == 1);
    } else if (this.common.ToLowerCase(this.router.url.split('/')[3]) == 'preinit') {
      this.EmployeeDetail.RegistrationType = 'PreOnboarding';
      this.RegistrationTypesFilter = this.RegistrationTypes.filter((e: any) => e.RegistrationTypeID == 2);
    }
    this.route.params.subscribe(params => this.EmployeeDetail.EmployeeCategory = this.common.ToLowerCase(params['type'])=='front'?'Front':this.common.ToLowerCase(params['type'])=='back'?'Back':'');

    this.common.getPageRights();
  }

  Validate(form: any) {
    if (form.valid) {
      this.InsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  async InsertUpdate() {
    await this.common.getPageRights();
    if (this.common.PageRight.IsAdd) {
      this.isDisabled = true;
      this.EmployeeDetail.EmployeeCategory = this.EmployeeDetail.EmployeeCategory.toLocaleUpperCase();
      this.employeeRegistration.InsertUpdate(this.EmployeeDetail).subscribe({
        next: (response) => {
          this.EmployeeDetail.EmployeeCategory = this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)=='front'?'Front':this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)=='back'?'Back':'';
          if (response.Error_Code == '349') {
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              if (result) {
                if (this.EmployeeDetail.RegistrationType == 'Manual') {
                  this.router.navigate(['onboarding/register/add/' + response.EmpMasterId + '/' + true]);
                } else if (this.EmployeeDetail.RegistrationType == 'PreOnboarding') {
                  this.router.navigate(['onboarding/preonboarding/preonboardingsetup/', response.EmpMasterId]);
                }
              }
            });
          } else {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.EmployeeDetail.EmployeeCategory = this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)=='front'?'Front':this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)=='back'?'Back':'';
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
    }
  }

  close() {
    if (this.common.ToLowerCase(this.router.url.split('/')[3]) == 'preinit') {
      this.router.navigate(['onboarding/preonboarding' + '/' + this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)]);
    } else {
      this.router.navigate(['onboarding/register' + '/' + this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)]);
    }

  }
}
